import { api } from "../../axios";

export const actions = {

    //PrePlanningApi
    GetPrePlanningApis(context, data){
        return api.get(`PrePlanningApi/TargetTemplateDeliveryUnit/${data}`);
    },
    GetPrePlanningApisByOPCR(context, data){
        return api.get(`PrePlanningApi/PreOPCR/${data}`);
    },
    GetPrePlanningApisByTargetAndOPCR(context, data){
        return api.get(`PrePlanningApi/PreOPCR/Target/${data.preOPCRId}/${data.preplanningTargetId}`);
    },
    GetPrePlanningApisByDU(context, data){
        return api.get(`PrePlanningApi/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetPrePlanningBudgets(context, data){
        return api.get(`PrePlanningApi/PrePlanningBudgetLineItem/${data}`);
    },
    GetSinglePrePlanningApi(context, data){
        return api.get(`PrePlanningApi/${data}`);
    },
    UpdatePrePlanningApi(context, data){
        return api.put(`PrePlanningApi/${data.id}`, data);
    },
    DeletePrePlanningApi(context, data){
        return api.delete(`PrePlanningApi/${data}`);
    },
    CreatePrePlanningApi(context, data){
        return api.post(`PrePlanningApi/Create`, data);
    },
    PreplanningApiDates(context, data){
        return api.put(`PrePlanningApi/Dates/${data.id}`, data);
    },
}